import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { isAfter, startOfYesterday } from 'date-fns';
import { CheckCircle } from 'lucide-react';

import { ProgressBar } from '@labradorsports/components';
import { JoinTypes } from '@labradorsports/constants';

import { InvitePlayersModal } from '../../shared/interface/index.js';
import { Selectors, useLoadRosterQuery } from '../../store/index.js';

const OnboardingStatusCard: FC = () => {
    const { data: { playerRoster } = {} } = useLoadRosterQuery();
    const currentTeam = useSelector(Selectors.currentTeam);
    const userRole = useSelector(Selectors.currentUserTeamRole);
    const unregisteredPlayers = playerRoster.filter((plr) => !plr.uid);
    const [showInvite, setShowInvite] = useState(false);

    const hideInviteModal = () => setShowInvite(false);

    const invitePlayers = () => setShowInvite(true);

    const joinedToday = playerRoster.filter(
        (player) => player.joinedAt && isAfter(player.joinedAt, startOfYesterday())
    );

    const showOnboarding = joinedToday.length > 0 && userRole !== JoinTypes.PLAYER;

    if (!showOnboarding || !currentTeam) {
        return null;
    }

    return (
        <div className="onboarding-status-card notification-item read">
            <InvitePlayersModal team={currentTeam} onClose={hideInviteModal} open={showInvite} />
            <div className="notification-content">
                <div className="notification-header">
                    <div className="notification-title">
                        <h3>New Players Joined {currentTeam.name}</h3>
                    </div>
                </div>

                <div className="notification-body">
                    <p className="mb-2">Great news! More players have joined your team.</p>
                    <div>
                        <div className="d-flex">
                            <div className="flex-grow-1">Signup Progress</div>
                            <em>
                                {playerRoster.length - unregisteredPlayers.length} of {playerRoster.length}
                            </em>
                        </div>
                        <ProgressBar
                            progress={((playerRoster.length - unregisteredPlayers.length) / playerRoster.length) * 100}
                        />
                    </div>
                    <div className="recently-joined">
                        <p>Recently Joined</p>
                        {joinedToday.map((player) => (
                            <div key={player.id}>
                                <CheckCircle size={16} /> {player.firstName} {player.lastName}
                            </div>
                        ))}
                    </div>
                    <div className="text-end">
                        <Button onClick={invitePlayers}>Send Reminder</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnboardingStatusCard;
